/**
 * Avalara © 2017
 * file: engines/opus_ui/src/AvataxTrustfileCard.js
 */

import React, { Component } from 'react';
import AvataxCard from './AvataxCard';

class AvataxTrustfileCard extends Component {
  render() {
    const { deliveryInfo } = this.props;

    return <AvataxCard deliveryInfo={deliveryInfo} />;
  }
}

export default AvataxTrustfileCard;
